import type { IAdViewLink } from "@finn-no/adview-provider-frontend-types";
import { Trans } from "@lingui/react";
import usePulse from "src/utils/pulse-tracking/usePulse.ts";
import { Icon } from "../Icon.tsx";
import { ScreenReaderSeparator } from "../ScreenReaderSeparator.tsx";
import { evGuideLinkClicked } from "./evTrackingEvents.ts";

type Props = {
  links?: IAdViewLink[];
  title?: string;
};

export const EvFaqLinks = ({ links, title }: Props) => {
  const { trackClick } = usePulse();

  if (!links?.length) {
    return null;
  }

  return (
    <div className="my-4">
      <h3 className="t4 mt-0 mb-12">
        {title || (
          <Trans
            id="itemPageLayout.ev.faqLinks.title"
            message="Frequently asked questions"
            comment="Heading above the article links at the bottom of the cards in the EV info section"
          />
        )}
      </h3>

      <div className="flex flex-col gap-8">
        {links.map((link) => (
          <a
            key={link.uri}
            href={link.uri}
            target="_blank"
            rel="noopener nofollow"
            className="w-fit flex items-center gap-4"
            onClick={() => {
              // Tracking event: MO_ev107
              trackClick(evGuideLinkClicked(link));
            }}
          >
            {link.title}
            <ScreenReaderSeparator />
            <Icon name="LinkExternal" className="inline-block align-baseline" />
          </a>
        ))}
      </div>
    </div>
  );
};
